import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { ADMIN_PANEL_ROLES } from '../models/user.model';
import { AuthService } from '../services/auth.service';

function isAdminPanelRole(roleName: string | null | undefined): boolean {
  return !!roleName && (ADMIN_PANEL_ROLES as readonly string[]).includes(roleName);
}

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // Debt cases and lawyers: super_admin, administrator and accountant only, as the server's IsFinanceEditor;
  // is_staff or an "admin" role name is not enough
  if (route.data['financeOnly'] === true) {
    if (authService.canManageAccounting()) return true;
    router.navigate([authService.getLandingRoute()]);
    return false;
  }

  // ADMIN_PANEL_ROLES open every admin page; accounting pages also let ACCOUNTING_ROLES in
  const accountingPage = route.data['accounting'] === true;
  const panelRole = isAdminPanelRole(authService.currentUser?.()?.role_name);
  if (
    !authService.isAdmin() &&
    !panelRole &&
    !(accountingPage && authService.canManageAccounting())
  ) {
    router.navigate([authService.getLandingRoute()]);
    return false;
  }

  return true;
};
